import React from "react";
import Skeleton from "react-loading-skeleton";
import { FaMagnifyingGlass, FaCircleXmark } from "react-icons/fa6";

import Input from "../../atoms/Input/Input";
import { SearchInputProps } from "./SearchInput.types";

import "./SearchInput.scss";

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
  loading,
  inverted,
}) => (
  <div className="mp-molecules-searchinput--main">
    {loading ? (
      <div className="skeleton-container">
        <Skeleton className="skeleton" inline={true} />
      </div>
    ) : (
      <>
        <div className={`search-icon${inverted && " inverted"}`}>
          <FaMagnifyingGlass />
        </div>
        <Input
          id="search_input"
          inverted={inverted}
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          hasIcon={true}
        />
        {value !== "" && (
          <div
            className={`close-icon${inverted && " inverted"}`}
            onClick={() => onChange("")}
          >
            <FaCircleXmark />
          </div>
        )}
      </>
    )}
  </div>
);

export default SearchInput;
